import { createApi } from '@reduxjs/toolkit/query/react';

import { apiCompanySettings } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { CompanySetting } from '~main/models';

export const typePrefix = 'companySettings';

export const companySettingsApi = createApi({
  reducerPath: 'companySettingsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiCompanySettings }),
  tagTypes: ['companySettings'],
  endpoints: (builder) => ({
    getCompanySettings: builder.query<CompanySetting[], Request | void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: [{ type: 'companySettings', id: 'LIST' }],
      transformResponse: (payload) => unwrap<CompanySetting[]>(payload),
    }),
    createCompanySetting: builder.mutation<CompanySetting, { lookup_setting_id: string; value: string }>({
      query: (body) => ({ url: ``, method: 'POST', body }),
      invalidatesTags: [{ type: 'companySettings', id: 'LIST' }],
    }),
    updateCompanySetting: builder.mutation<CompanySetting, { id: string; value: string }>({
      query: ({ id, value }) => ({ url: `/${id}`, method: 'PUT', body: { value } }),
      invalidatesTags: [{ type: 'companySettings', id: 'LIST' }],
      transformResponse: (payload) => unwrap<CompanySetting>(payload),
    }),
  }),
});

export const { useGetCompanySettingsQuery, useCreateCompanySettingMutation, useUpdateCompanySettingMutation } =
  companySettingsApi;
